/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentDetailResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentDetailResponseOutputReceivedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const incidentDetailResponseOutputPriorityMax = 4;

export const incidentDetailResponseOutputVersionExclusiveMin = 0;
export const incidentDetailResponseOutputVersionMax = 9007199254740991;

export const incidentDetailResponseOutputCustomerOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentDetailResponseOutputTeamOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentDetailResponseOutputSourceEventAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const incidentDetailResponseOutputExtraInformationMax = 50;

export const incidentDetailResponseOutputAcknowledgementOneAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const incidentDetailResponseOutputAcknowledgementOneActorOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentDetailResponseOutputAcknowledgementOneActorTwoDeliveryChannelRegExp =
  new RegExp('^[-a-z0-9]{1,80}$');
export const incidentDetailResponseOutputResolutionOneAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const incidentDetailResponseOutputResolutionOneActorUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const IncidentDetailResponseOutput = zod.object({
  id: zod.uuid().regex(incidentDetailResponseOutputIdRegExp),
  title: zod.string(),
  receivedAt: zod.iso
    .datetime({ offset: true })
    .regex(incidentDetailResponseOutputReceivedAtRegExp),
  sourceKind: zod.enum(['monitoring', 'phone']),
  status: zod.enum(['open', 'acknowledged', 'resolved']),
  priority: zod.int().min(1).max(incidentDetailResponseOutputPriorityMax),
  version: zod
    .int()
    .gt(incidentDetailResponseOutputVersionExclusiveMin)
    .max(incidentDetailResponseOutputVersionMax),
  customer: zod.union([
    zod.object({
      id: zod.uuid().regex(incidentDetailResponseOutputCustomerOneIdRegExp),
      name: zod.string(),
    }),
    zod.null(),
  ]),
  team: zod.union([
    zod.object({
      id: zod.uuid().regex(incidentDetailResponseOutputTeamOneIdRegExp),
      name: zod.string(),
    }),
    zod.null(),
  ]),
  description: zod.union([
    zod.string().describe('Optional incident description, preserved as inert text.'),
    zod.null(),
  ]),
  sourceReference: zod.union([
    zod.string().describe('Optional source reference, preserved without dereferencing.'),
    zod.null(),
  ]),
  sourceEventAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(incidentDetailResponseOutputSourceEventAtOneRegExp),
    zod.null(),
  ]),
  extraInformation: zod
    .array(
      zod.object({
        key: zod.string(),
        value: zod.string(),
      }),
    )
    .max(incidentDetailResponseOutputExtraInformationMax),
  acknowledgement: zod.union([
    zod.object({
      at: zod.iso
        .datetime({ offset: true })
        .regex(incidentDetailResponseOutputAcknowledgementOneAtRegExp),
      actor: zod.union([
        zod.object({
          kind: zod.literal('user'),
          userId: zod
            .uuid()
            .regex(incidentDetailResponseOutputAcknowledgementOneActorOneUserIdRegExp),
          displayName: zod.union([
            zod.string().describe('Known historical actor display name.'),
            zod.null(),
          ]),
        }),
        zod.object({
          kind: zod.literal('link'),
          deliveryChannel: zod
            .string()
            .regex(incidentDetailResponseOutputAcknowledgementOneActorTwoDeliveryChannelRegExp),
        }),
        zod.object({
          kind: zod.literal('voice'),
          deliveryChannel: zod.literal('voice'),
        }),
      ]),
    }),
    zod.null(),
  ]),
  resolution: zod.union([
    zod.object({
      at: zod.iso
        .datetime({ offset: true })
        .regex(incidentDetailResponseOutputResolutionOneAtRegExp),
      actor: zod.object({
        kind: zod.literal('user'),
        userId: zod.uuid().regex(incidentDetailResponseOutputResolutionOneActorUserIdRegExp),
        displayName: zod.union([
          zod.string().describe('Known historical actor display name.'),
          zod.null(),
        ]),
      }),
    }),
    zod.null(),
  ]),
});

export type IncidentDetailResponseOutput = zod.input<typeof IncidentDetailResponseOutput>;
export type IncidentDetailResponseOutputOutput = zod.output<typeof IncidentDetailResponseOutput>;
